import { render, staticRenderFns } from "./gc-batch-stock-adjustment.vue?vue&type=template&id=c1aaf010"
import script from "./gc-batch-stock-adjustment.vue?vue&type=script&lang=js"
export * from "./gc-batch-stock-adjustment.vue?vue&type=script&lang=js"
import style0 from "./gc-batch-stock-adjustment.vue?vue&type=style&index=0&id=c1aaf010&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports